import { OfferingDetails } from 'components/business/offering/OfferingDetails';
import { Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';

interface Props {
  business: consumer.IBusinessConfig;
  offering: consumer.Offering;
}

export default class RescheduleExperienceDetails extends BaseComponent<Props> {
  render() {
    const { business, offering } = this.props;
    const consumerUrl = `/${business.domainName}`;
    return (
      <div className="Reschedule-body--borderBottom">
        <div className="Receipt-container--header">
          <div className="Receipt-container--businessAndConfirmationContainer">
            <Typography component="h3" variant="heading04">
              <Anchor className="Receipt-content--nameLink" href={consumerUrl}>
                {business.name}
              </Anchor>
            </Typography>
          </div>
        </div>
        <div className="Receipt-container--body">
          <div className="Receipt-container--section is-inline">
            <OfferingDetails
              business={business}
              offering={offering}
              isReschedule
              includeAccessKey={false}
            />
          </div>
        </div>
      </div>
    );
  }
}
